// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const dismissed = "Insights__dismissed__kt4rE";
export const dismissedAnimation = "Insights__dismissedAnimation__V+Vvm";
export const fullWidth = "Insights__fullWidth__eAw5J";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const insightWidth = "var(--insight-width)";
export const insights = "Insights__insights__HpvLR";
export const insightsItem = "Insights__insightsItem__jwUNP";
export const medium = "500";
export const prevAnimation = "Insights__prevAnimation__R5uA1";
export const previous = "Insights__previous__8RGd1";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";